//@flow
import React from 'react';

export default ({ className, style }: { className?: string, style?: any }) => (
  <svg
    className={className}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="72"
    height="72"
    viewBox="0 0 72 72"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill="#7E61EA"
      d="M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36z"
    />
    <path
      fill="#FFF"
      transform="translate(17.09 14.37)"
      d="M18.895 0c-2.474-.02-4.927.447-7.22 1.38-2.29.93-4.374 2.307-6.13 4.048-1.757 1.74-3.152 3.813-4.103 6.096C.49 13.808 0 16.257 0 18.73c0 2.473.49 4.923 1.442 7.206.95 2.283 2.346 4.355 4.102 6.096 1.757 1.742 3.84 3.118 6.132 4.05 2.292.93 4.745 1.4 7.22 1.377h.016v7.214s18.712-7.207 18.712-25.937c0-2.46-.483-4.897-1.424-7.17-.94-2.273-2.32-4.34-4.06-6.078-1.74-1.74-3.804-3.12-6.077-4.063C23.79.485 21.355 0 18.895 0z"
    />
    <path
      fill="#7E61EA"
      transform="translate(34.27 39.76)"
      d="M1.72 3.442c.95 0 1.722-.77 1.722-1.72C3.442.77 2.672 0 1.722 0 .77 0 0 .77 0 1.72s.77 1.722 1.72 1.722z"
    />
    <path
      fill="#7E61EA"
      transform="translate(30.26 24.49)"
      d="M5.733 0c-1.44.002-2.83.543-3.89 1.517C.783 2.49.123 3.827 0 5.263l2.85.408c.005-.378.085-.752.235-1.1.15-.348.367-.663.64-.927.27-.263.592-.47.944-.61.35-.14.727-.21 1.106-.205.38.006.752.086 1.1.236.348.15.663.367.927.64.264.27.472.59.612.943.14.352.21.728.203 1.107 0 2.87-4.032 2.87-4.032 6.883v.323H6.88v-.323c0-2.293 4.609-2.868 4.609-6.883-.003-1.526-.61-2.99-1.69-4.067C8.722.607 7.26 0 5.734 0z"
    />
  </svg>
);
